<template>
  <div
    id="search-basic"
    v-loading="loading">
    <!-- <div class="pay-header">
      Event Payment
    </div> -->
    <div class="pay-content">
      <div class="pay-info">
        <div
          class="slug-info wrap3"
          :title="iframeData.slugName">
          {{ iframeData.slugName }}
        </div>
        <div class="slug-date">
          {{ iframeData.slugDate }}
        </div>
        <div class="grid-name">
          {{ iframeData.gridName }}
        </div>
      </div>
      <div class="plan-detail">
        <div
          class="plan-info"
          v-html="planDescription">
          This event can be used unlimitedly after a one-time purchase.
        </div>
        <div class="price-wrap">
          <div
            v-if="hasTakelive"
            class="paid">You already have the take live permission.</div>
          <div
            v-if="hasDownload"
            class="paid">You already have the download permission.</div>
          <template v-for="item in priceList" >
            <el-radio
              v-model="radio"
              v-if="item.isShow"
              :key="item.id"
              :disabled="item.disable"
              :label="item.action">{{ item.info }}</el-radio>
          </template>

          <!-- <el-radio v-model="radio" label="2">备选项</el-radio> -->
        </div>
      </div>
    </div>
    <div class="pay-footer">
      <div class="price">${{ this.selectPlanPrice }}</div>
      <div class="confirm">
        <el-button
          @click="handleCheckOut"
          :disabled="!radio">Buy</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="360px"
      :modal="false"
      custom-class="free-dialog search-dialog"
      :before-close="handleClose"
    >
      <img
        src="@/assets/svg/allright.svg"
        alt="">
      <!-- <div class="start" v-if="planisSub">START TRIAL</div> -->
      <div class="start">Your Subscription has been Modified</div>
      <!-- <div class="start" v-if="planIsPostPay">POST PAY COMPLETE</div> -->

      <div class="info">Thank you, your subscription has been successfully modified, and the changes have been applied to your account. You may resume use.</div>
      <!-- <div class="info" v-if="planIsPostPay">Thank you, We will follow-up centralized deduction. You can start use it now.</div> -->
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="handleClose">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import { userHasSubscription, handleNewSub, getPlans } from '@/common/checkuser.js'
export default {
  data () {
    return {
      priceList: [],
      radio: '',
      selectPlanPrice: '',
      dialogVisible: false,
      planDetail: null,
      queryPlanLoading: false, // 查plan 状态
      querySubLoading: false, // 查订阅状态
      checkOutLoading: false, // 支付loading
      hasDownload: false, // 已订阅 download
      hasTakelive: false, // 已订阅 takelive
      planDescription: ''
    }
  },
  created () {
    this.handleGetPlans()
  },
  methods: {
    handleClose () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    handlePaySuccess () {
      const params = {
        type: 'success',
        from: 'billing',
        data: this.iframeData.payType
      }
      window.parent.postMessage(params, '*')
    },
    handlePayStep (description) {
      const params = {
        type: 'step',
        from: 'billing',
        data: {
          info: 'payError',
          description,
          payType: this.iframeData.payType
        }
      }
      window.parent.postMessage(params, '*')
    },
    handleGetPlans () {
      this.queryPlanLoading = true
      if (this.iframeData && this.iframeData.objectId) {
        const params = {
          customerId: this.emailid,
          product: 'Tvusearch',
          objectId: this.iframeData.objectId,
          excludeGlobal: true
        }
        getPlans(params).then(({ data }) => {
          if (data) {
            this.queryPlanLoading = false
            this.planDetail = data.plan.plans[0]
            this.planDescription = this.planDetail.description
            this.handlePlanDetail()
          }
        })
      } else {
        setTimeout(() => {
          this.handleGetPlans()
        }, 1000)
      }
    },
    // 去查询订阅的信息
    querySub () {
      this.querySubLoading = true
      const params = {
        product: 'Tvusearch',
        objectId: this.iframeData.objectId,
        status: 0
      }
      userHasSubscription(params).then(({ data, loading }) => {
        if (data) {
          this.querySubLoading = false
          const subscriptions = data.subscription.subscriptions
          if (subscriptions.length) {
            const arr = subscriptions[0].chargeItems
            arr.forEach(i => {
              if (i.action == 'tvusearch-download') {
                this.hasDownload = true
              } else if (i.action == 'tvusearch-takelive') {
                this.hasTakelive = true
              }
            })
            // 是否显示addon
            this.priceList.forEach(i => {
              if (i.action == 'tvusearch-download') {
                i.isShow = !this.hasDownload
              } else if (i.action == 'tvusearch-takelive') {
                i.isShow = !this.hasTakelive
              }
            })
          }
        }
        if (this.iframeData.type) {
          let radio = 'tvusearch-' + this.iframeData.type
          const flag = this.priceList.some(i => i.action == radio && i.isShow)
          radio = flag ? radio : ''
          this.radio = radio
          this.priceList.forEach(i => {
            i.disable = i.action !== this.radio
          })
        }
        console.log(data, loading)
      })
    },
    // 出来plan数据
    handlePlanDetail () {
      const arr = this.planDetail.chargeItems
      const priceList = []
      if (arr.length == 0) return
      arr.forEach((i, index) => {
        const obj = { id: index }
        let meta = JSON.parse(i.metadata)
        obj.price = meta.price / 100
        obj.isShow = true
        obj.action = i.action
        if (i.action == 'tvusearch-download') {
          obj.label = i.addonId
          obj.info = `$ ${obj.price} Download and Share clips to Social Media`
          priceList.push(obj)
        } else if (i.action == 'tvusearch-takelive') {
          obj.label = i.addonId
          obj.info = `$ ${obj.price} Take Live to your TVU receiver`
          priceList.push(obj)
        }
      })
      this.priceList = priceList
      this.querySub()
    },
    // 点击支付
    handleCheckOut () {
      this.checkOutLoading = true
      const chargeItems = {
        [this.radio]: 1
      }
      let name = ''
      if (this.iframeData.type == 'takelive') {
        name = this.iframeData.gridName
      } else if (this.iframeData.type == 'download') {
        name = this.iframeData.exportFilename
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvusearch',
        planId: this.planDetail.id,
        objectId: this.iframeData.objectId,
        description: `${this.planDetail.name} ${this.emailid} ${this.iframeData.type} (${name})`,
        chargeItems: JSON.stringify(chargeItems)
      }
      console.log(params)
      handleNewSub(params, this).then(res => {
        console.log(res)
        this.checkOutLoading = false
        this.dialogVisible = true
        this.handlePaySuccess()
        this.querySub()
        if (res.info == 'paySuccess') {
          this.payType = 'paid'
        } else if (res.info == 'POST-PAY') {
          this.payType = 'postpay'
        }
      }).catch((err) => {
        this.handlePayStep(err.info)
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.checkOutLoading = false
      })
    }
  },
  watch: {
    radio () {
      const item = this.priceList.find(i => i.action == this.radio)
      console.log(item)
      if (item) {
        this.selectPlanPrice = item.price
      } else {
        this.selectPlanPrice = 0
      }
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email,
      iframeData: 'iframeData'
    }),
    loading () {
      return this.checkOutLoading || this.queryPlanLoading || this.querySubLoading
    }
  }
}
</script>

<style lang="less" scoped>
#search-basic {
  width: 400px;
  margin: 0 auto;
  min-height: 366px;
  text-align: left;
  position: relative;
  top: -20px;
  .pay-header {
    color: #333333;
    font-weight: 700;
    line-height: 32px;
    border-bottom: 1px solid #dbdbdb;
    margin: 0 20px;
    padding-bottom: 15px;
    font-size: 24px;
  }
  .pay-info {
    margin: 0 20px;
    border-bottom: 1px solid #dbdbdb;
    padding: 20px 0;
    .slug-info {
      color: #333333;
      font-weight: 700;
    }
    .slug-date {
      margin: 5px 0;
    }
    .slug-date, .grid-name {
      color: #999999;
      font-size: 14px;

    }
  }
  .pay-footer {
    width: calc(100% - 40px);
    height: 80px;
    margin: 0 20px;
    display: flex;
    // position: absolute;
    // bottom: 0;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--dialog-border-color);
  }
  .plan-detail {
    margin: 30px 20px;
    min-height: 150px;
    .plan-info {
      color: #333;
      margin: 10px 0;
      word-break: break-word;
    }
    .el-radio {
      display: block;
      margin: 10px;

    }
      ::v-deep .el-radio__input.is-checked+.el-radio__label {
        color: #33AB4F;
      }
      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        background: #33AB4F;
      }
    .paid {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #33AB4F;
      margin: 10px;
    }
  }
  .price {
    color: #33AB4F;
  }
  .el-button {
    background: #33AB4F;
    color: #dbdbdb;
    padding: 12px 30px;
    border: none;
  }
}
/deep/ .free-dialog.search-dialog {
  // height: 275px;
  border-radius: 15px;
  .start {
    color: #000;
    font-weight: 700;
    margin: 10px 0;
  }
  .info {
    // width: 200px;
    margin: 0 auto;
    font-weight: 400;
    color: #979797;
    font-size: 14px;
    line-height: 16px;
    word-break: break-word;
  }
  .el-icon-close {
    color: #979797;
  }
  .el-dialog__body {
    text-align: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
